import { ALERT_LEVELS } from './constants.js';

const LEVEL_RANK = { red: 3, yellow: 2, green: 1 };

/** Métricas de alertas alineadas al equipo directo del supervisor. */

export function countAlertsByLevel(alerts = []) {
    const counts = { red: 0, yellow: 0, green: 0 };
    for (const a of alerts) {
        if (a.level && counts[a.level] !== undefined) counts[a.level]++;
    }
    return counts;
}

export function countPeopleWithAlerts(alerts = []) {
    const ids = new Set();
    for (const a of alerts) {
        const id = a.employee_id ?? a.trabajador_id;
        if (id != null) ids.add(String(id));
    }
    return ids.size;
}

export function summarizeSupervisorAlerts(alerts = []) {
    const byLevel = countAlertsByLevel(alerts);
    const total = alerts.length;
    const people = countPeopleWithAlerts(alerts);
    return { byLevel, total, people };
}

/** Una fila por persona: estado actual del equipo + alertas activas agrupadas. */
export function groupAlertsByPerson(alerts = [], teamData = []) {
    const teamById = Object.fromEntries(teamData.map((w) => [String(w.id), w]));
    const map = new Map();

    for (const alert of alerts) {
        const eid = String(alert.employee_id ?? alert.trabajador_id ?? '');
        if (!eid) continue;

        if (!map.has(eid)) {
            const worker = teamById[eid];
            map.set(eid, {
                employeeId: eid,
                nombre: alert.trabajador_nombre || worker?.nombre || 'Colaborador',
                estado_hoy: worker?.estado_hoy ?? null,
                alerts: [],
                topLevel: 'green',
                primaryAlert: null,
            });
        }
        const row = map.get(eid);
        row.alerts.push(alert);
        const rank = LEVEL_RANK[alert.level] || 0;
        const topRank = LEVEL_RANK[row.topLevel] || 0;
        if (rank >= topRank) {
            row.topLevel = alert.level;
            row.primaryAlert = alert;
        }
    }

    return Array.from(map.values()).sort(
        (a, b) => (LEVEL_RANK[b.topLevel] || 0) - (LEVEL_RANK[a.topLevel] || 0)
    );
}

export function alertLevelLabel(level) {
    return ALERT_LEVELS[level]?.label || level;
}

export function alertLevelEmoji(level) {
    return ALERT_LEVELS[level]?.emoji || '·';
}

/** Texto legible del motivo de la alerta para el supervisor. */
export function getAlertMotive(alert) {
    const text = (alert?.description || alert?.descripcion_interna || '').trim();
    if (text) return text;
    const code = alert?.alert_code || '';
    if (code.includes('RED') || code.includes('SEED_DEMO_RED')) {
        return 'El sistema detectó señales de carga o riesgo en la jornada reciente de esta persona.';
    }
    if (code.includes('YEL')) {
        return 'Conviene observar el clima del turno; hay señales que ameritan una conversación breve.';
    }
    return 'Señal informativa del sistema según registro de jornada o encuesta semanal.';
}
